import none from "./none";

export default function(series) {
  return none(series).reverse();
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-shape/src/order/reverse.js
// module id = 481
// module chunks = 0